import React from "react";
import { PlanosContratacaoAnualPage } from "./planos-contratacao-anual.page";

export function PlanosContratacaoAnualFactory() {
    return (
        <PlanosContratacaoAnualPage></PlanosContratacaoAnualPage>
    );
}
